import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'



import 'bootstrap/dist/js/bootstrap.js'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

//动画插件-> https://github.com/michalsnik/aos
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init({
  // delay:100,//延迟
  // duration:100,//动画时长
  //引入animate.css的配置
  useClassNames: true,
  initClassName: false,
  animatedClassName: 'animated',
  // animatedClassName: 'animate',
})
//引入animate.css https://animate.style/
import 'animate.css';//最新使用方法,但是有前缀,不与aos兼容
import 'animate.css/animate.compat.css';//兼容3版本的样式


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
